import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface ImageLightboxData {
	src: string;
	alt: string;
	caption?: string;
}

@Injectable({ providedIn: "root" })
export class ImageLightboxService {
	private readonly imageSubject = new BehaviorSubject<ImageLightboxData | null>(
		null
	);
	private restoreFocusTarget: HTMLElement | null = null;

	readonly image$ = this.imageSubject.asObservable();

	constructor(@Inject(DOCUMENT) private readonly document: Document) {}

	open(image: ImageLightboxData, trigger?: HTMLElement): void {
		if (!image.src) {
			return;
		}

		if (!this.imageSubject.value) {
			this.restoreFocusTarget =
				trigger ?? (this.document.activeElement as HTMLElement | null);
		}

		this.imageSubject.next({ ...image });
	}

	close(): void {
		if (!this.imageSubject.value) {
			return;
		}

		const restoreFocusTarget = this.restoreFocusTarget;
		this.restoreFocusTarget = null;
		this.imageSubject.next(null);

		setTimeout(() => {
			if (restoreFocusTarget?.isConnected) {
				restoreFocusTarget.focus({ preventScroll: true });
			}
		});
	}
}
